﻿import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'app/_services/authentication.service';
import { LogService } from 'app/_services/logmanager.service';
import { GlobalsService } from 'app/_services/globals.service';

@Injectable()
export class AuthGuard implements CanActivate {
    private token: string;
    private codiSecretaria: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private globalStorage: GlobalsService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        LogService.log('AuthGuard', 'canActivate');

        const currentuseri = this.globalStorage.getItem('currentUser');
        if (currentuseri) {
            LogService.log('AuthGuard', 'canActivate -> currentUser');
            LogService.log('AuthGuard', currentuseri);

            const currentuser = JSON.parse(currentuseri);
            if (currentuser.username) {
                this.authenticationService.checkSession(currentuser.token)
                    .subscribe(
                        () => {
                            LogService.log('AuthGuard', 'canActivate -> subscribe -> data');
                        },
                        () => {
                            this.authenticationService.logout();
                        });

                // Obtenemos, si existe, el codigo 'secretaria' a traves del token
                this.codiSecretaria = this.route.snapshot.queryParams['secretaria'] || '';

                if (this.codiSecretaria !== '') {
                    LogService.log('AuthGuard', 'La variable secretaria ve definida en el token.');
                    this.globalStorage.setItem('secretaria', this.codiSecretaria);
                } else {
                    LogService.log('AuthGuard', 'La variable secretaria no ve definida en el token.');
                    this.codiSecretaria = this.globalStorage.getItem('secretaria');
                }

                // Devolvemos true, el subscribe se encarga de salir si ya no es correcto
                return true;
            }
        } else {
            LogService.log('AuthGuard', 'No loginat. Carregant login');
        }

        // not logged in so redirect to login page with the return url
        this.token = this.route.snapshot.queryParams['token'] || '';
        const url = state.url.split('?');
        this.globalStorage.setItem('returnUrl', url[0]).then(
            () => {
                this.globalStorage.setItem('navigationExtras', JSON.stringify(route.queryParams)).then(
                    () => {
                        this.router.navigate(['/login']);
                    }
                );
            }
        );

        return false;
    }
}
